import { default as sagaMiddlewareFactory } from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension';
import { HISTORY } from 'src/constants/history';
import { AnyAction, applyMiddleware, createStore, Store, StoreEnhancer } from 'redux';
import { RootState } from 'src/state/RootState';
import { identity } from 'src/utils/identity';
import { rootReducer } from 'src/reducers/rootReducer';
import { DEFAULT_STATE } from 'src/constants/defaultState';
import { rootSaga } from 'src/sagas/rootSaga';
import { Clients } from '@xiag-search/sdk';

export function initStore(clients: Clients, dnt: boolean): Store<RootState> {
    const sagaMiddleware = sagaMiddlewareFactory();

    type Identity<T> = (value: T) => T;
    type Enhancer = StoreEnhancer<{}, RootState>;

    const composeEnhancers: Identity<Enhancer> = process.env.NODE_ENV === 'development'
        ? composeWithDevTools
        : identity;
    const applicationEnhancer = composeEnhancers(applyMiddleware(
        sagaMiddleware,
        routerMiddleware(HISTORY),
    ));

    const sdk = { dnt, clients };

    const STORE = createStore<RootState, AnyAction, {}, {}>(
        rootReducer,
        { ...DEFAULT_STATE, sdk },
        applicationEnhancer,
    );
    sagaMiddleware.run(rootSaga);

    return STORE;
}
